/* eslint-disable no-plusplus */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-useless-constructor */
import React from 'react';
import { connect } from 'react-redux';

class HeaderSuggests extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  showDidYouMean = (suggests, dismissedClick) => !!(suggests && suggests.length) && !dismissedClick;

  render() {
    const {
      suggests, dismissedClick, setSuggest, term,
    } = this.props;
    const showOrHide = this.showDidYouMean(suggests, dismissedClick)
      ? 'show'
      : '';
    const splittedTerm = term.split(' ').map(it => it.trim());

    let keyCounter = 0;

    return (
      <div
        className={`search-results ${showOrHide}`}
        style={{
          overflow: 'auto',
          overflowWrap: 'break-word',
          maxWidth: '50vw',
        }}
      >
        {!!(suggests && suggests.length)
          && suggests.map((sug, idx) => {
            const termBolded = sug.split(' ').reduce((acc, it, i) => {
              const trimmedText = it.trim();
              keyCounter++;

              const isTermIncluded = !trimmedText.includes(splittedTerm[0]);
              const style = isTermIncluded ? { fontWeight: 'bold' } : {};

              const spanElement = (
                <span
                  key={`sugs${idx}${trimmedText}${keyCounter}`}
                  onClick={e => setSuggest(e, sug)}
                  style={style}
                >
                  &nbsp;
                  {trimmedText}
                </span>
              );

              return i === 0
                ? [...acc, spanElement]
                : [...acc, ' ', spanElement];
            }, []);
            return (
              <span
                key={`sug${idx}`}
                className="cursorPointer cut-text t"
                onClick={e => setSuggest(e, sug)}
                style={{ overflowWrap: 'break-word' }}
              >
                {termBolded}
              </span>
            );
          })}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  suggests: state.activities.suggests,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderSuggests);
